var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.144287,
    y: 0.0898438,
    width: 42,
    height: 42,
    fill: "#F9F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1150_3328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 19V23.26H26.9199C26.6599 24.63 25.8798 25.7901 24.7098 26.57L28.2798 29.3401C30.3598 27.4201 31.5598 24.6001 31.5598 21.2501C31.5598 20.4701 31.4898 19.7201 31.3598 19.0001L20.9999 19Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8351 23.0938L14.03 23.7101L11.1799 25.9301C12.9899 29.52 16.6997 32.0001 20.9996 32.0001C23.9695 32.0001 26.4595 31.0201 28.2796 29.3401L24.7096 26.5701C23.7296 27.2301 22.4796 27.6301 20.9996 27.6301C18.1396 27.6301 15.7097 25.7001 14.8396 23.1001L14.8351 23.0938Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1799 16.0703C10.43 17.5503 10 19.2203 10 21.0002C10 22.7802 10.43 24.4502 11.1799 25.9302C11.1799 25.9401 14.84 23.0902 14.84 23.0902C14.62 22.4302 14.4899 21.7302 14.4899 21.0001C14.4899 20.27 14.62 19.5701 14.84 18.9101L11.1799 16.0703Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 14.38C22.6199 14.38 24.0598 14.94 25.2098 16.02L28.3598 12.87C26.4498 11.0901 23.9699 10 20.9998 10C16.6999 10 12.9899 12.47 11.1799 16.07L14.8399 18.91C15.7098 16.31 18.1399 14.38 20.9998 14.38Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1150_3328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.8ee05de4d7c950e9b8dc0305c3649c5e.svg";
export { ForwardRef as ReactComponent };